import { getContract } from "config/contracts";
import { useChainId } from "lib/chains";
import { useEffect, useState } from "react";
import multicall from "domain/multicall";
import FeeDistribution from "abis/MultiFeeDistribution.json";
import Multicall from "abis/Multicall.json";
import { BigNumber, ethers } from "ethers";
import { useWeb3React } from "@web3-react/core";
const useLockMMYLPInfo = () => {
  const { chainId } = useChainId();
  const { library } = useWeb3React();
  const [info, setInfo] = useState({
    lockedSupply: BigNumber.from(0),
    mulLockedSupply: BigNumber.from(0)
  });
  const multicallAddress = getContract(chainId, "Multicall");
  const FeeDistributionAddress = getContract(chainId, "MultiFeeDistribution");
  const fetchInfo = async () => {
    const multicallContract = new ethers.Contract(multicallAddress, Multicall.abi, library?.getSigner());
    const FeeDistributionContract = new ethers.Contract(FeeDistributionAddress, FeeDistribution.abi, library?.getSigner());
    if (FeeDistributionContract) {
      const calls = [];
      calls.push({
        address: FeeDistributionAddress,
        name: "lockedSupply",
        params: [],
      });
      calls.push({
        address: FeeDistributionAddress,
        name: "lockedSupplyWithMultiplier",
        params: [],
      });
      const dataMultiCall = await multicall(multicallContract, FeeDistribution.abi, calls);
      setInfo({
        lockedSupply: dataMultiCall[0][0],
        mulLockedSupply: dataMultiCall[1][0]
      })
    }
  }
  useEffect(() => {
    if (FeeDistributionAddress) {
      fetchInfo();
      const interval = setInterval(async () => {
        fetchInfo();
      }, 5000);
      return () => clearInterval(interval);
    }

  }, [FeeDistributionAddress])

  return { info };
}
export default useLockMMYLPInfo;
